<template>
  <div class="team-performance">
    <!-- 头部 -->
    <headerTop title="我的业绩"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="none-box">
        <label>我的业绩</label>
        <div class="total">
          <span v-if="totalPerformance === '-'">加载中...</span>
          <span v-else>+ {{ ((Number(totalPerformance) || 0) * 0.01).toFixed(2) }}  ↑</span>
        </div>
        <div class="note note-total">
          <div class="">
            <span>大区：</span>
            <span>{{totalData.max}}</span>
          </div>
          <div class="">
            <span>小区：</span>
            <span>{{totalData.min}}</span>
          </div>
          <div class="note-tip">以上业绩均按 PV 计算</div>
        </div>
        <img class="background" src="../../assets/images/total-bg@2x.png" alt="">
      </div>
      <div class="record">
        <div class="row">
          <div class="title">一级成员</div>
          <div class="total"></div>
          <!-- <div class="total">共{{totalMember}}人</div> -->
        </div>
        <t-table class="ui-table" borderType="none" :zebraStripe="true">
          <van-list
            v-model="dataLoading"
            :finished="dataFinished"
            finished-text="没有更多了"
            @load="dataLoad"
          >
            <t-tr v-for="(item, index) in dataList" :key="index" :tableIndex="index">
              <t-td align="left">
                <div class="member">
                  <div class="name">{{item.name}}</div>
                  <div class="row-line">
                    <div
                      class="phone"
                    >{{ `${item.phone}`.substring(0, 3) + '****' + `${item.phone}`.substring(7, 11) }}</div>
                    <div class="type">{{item.userType}}</div>
                  </div>
                </div>
              </t-td>
              <t-td align="right">
                <div>
                  <!-- <div class="price">总业绩：￥{{ (item.total * 0.01).toFixed(2) }}</div> -->
                  <div class="red" v-if="item.totalPerformance === undefined">加载中...</div>
                  <div class="red" v-else>+ {{ (item.totalPerformance * 0.01).toFixed(2) }} ↑</div>
                </div>
              </t-td>
            </t-tr>
          </van-list>
        </t-table>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import tTable from "@/components/table/tTable.vue";
import tTh from "@/components/table/tTh.vue";
import tTr from "@/components/table/tTr.vue";
import tTd from "@/components/table/tTd.vue";
import javaApi from "@/api/javaApi";

export default {
  data() {
    return {
      totalData: { max: "加载中...", min: "加载中..." },
      totalPerformance: "-",
      totalMember: 0,
      dataList: [],
      dataLoading: false,
      dataFinished: false,
      dataTotalPage: 1,
      dataPage: 1,
      dataPageSize: 10
    };
  },
  mounted() {
    javaApi
      .achievementSum(this.$store.state.userInfo.user_id)
      .then(res => {
        this.totalPerformance = res.total || 0;
        // 大区/小区业绩：后端单位为分，除以 100 显示为元，统一保留两位小数
        this.totalData.max = ((Number(res.max) || 0) / 100).toFixed(2);
        this.totalData.min = ((Number(res.min) || 0) / 100).toFixed(2);
      });
  },
  methods: {
    // 请求接口调用数据
    dataLoad() {
      const params = {
        page_number: this.dataPage,
        page_size: this.dataPageSize
      };
      javaApi.commissionTeamList(params).then(res => {
        const data = res.data;
        this.totalMember = res.pagination.totalCount || 0;
        console.log(data.list);
        // 遍历查询
        data.list.forEach(item => {
          this.getPerformanceByID(item.id);
        });
        if (data.list && data.list.length !== 0) {
          this.dataList = this.dataList.concat(data.list);
          this.dataTotalPage = res.pagination.maxPageNumber;
          this.dataLoading = false;
          if (this.dataPage >= this.dataTotalPage) {
            this.dataFinished = true;
          }
          this.dataPage++;
        } else {
          this.dataList = [];
          this.dataLoading = false;
          this.dataFinished = true;
        }
      });
    },
    getPerformanceByID(id) {
      javaApi
        .achievementSum(id)
        .then(res => {
          this.dataList.map((item, index) => {
            if (item.id === id) {
              Object.assign(item, {
                totalPerformance: res.total || 0
              })
              this.$set(this.dataList, index, item)
            }
          })
        });
    }
  },
  components: {
    headerTop,
    tTable,
    tTh,
    tTr,
    tTd
  }
};
</script>

<style lang="less" scoped>
.team-performance {
  .none-box {
    position: relative;
    margin: 15px 20px 5px;
    label {
      position: absolute;
      font-size: 14px;
      color: #ffffff;
      top: 15px;
      left: 55px;
    }
    .total {
      position: absolute;
      top: 40px;
      left: 55px;
      span {
        font-size: 24px;
        color: #ffffff;
      }
      i {
        margin-left: 5px;
        font-size: 12px;
        color: #ffffff;
      }
    }
    .note {
      position: absolute;
      top: 70px;
      left: 25px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      &.note-total{
        right: 25px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        >div{
          width: 50%;
        }
        >div.note-tip{
          width: 100%;
          margin-top: 5px;
          font-size: 11px;
          line-height: 1.4;
          color: rgba(255, 255, 255, 0.55);
        }
      }
    }
    .background {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .record {
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 10px 20px;
      border-bottom: 1px solid #eeeeee;
      .title {
        font-size: 16px;
        color: #333333;
      }
      .total {
        font-size: 12px;
        color: #999999;
      }
    }
    .member {
      text-align: left;
      .name {
        width: 170px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        color: #333333;
        line-height: 1.8;
      }
      .row-line {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .phone {
          font-size: 12px;
          color: #999999;
          margin-right: 5px;
        }
        .type {
          text-align: center;
          width: 48px;
          height: 18px;
          line-height: 18px;
          font-size: 12px;
          color: #6a5200;
          background: #ffe795;
          border-radius: 9px;
        }
      }
    }
    .price {
      font-size: 14px;
      color: #151515;
    }
    .red {
      text-align: right;
      font-size: 14px;
      color: #ff0000;
    }
  }
}
</style>
